import { connect } from 'react-redux';
import { dispatchify } from 'common/utils/utils';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';
import { getTeams, toggleModal, toggleSnackBar } from 'state/callers';
import Contributor from './Contributor';
import { licenseSelector } from 'state/selectors/license';

const mapStateToProps = state => {
  const { currentTeams, contributors, organization } = state;
  return {
    currentTeams,
    contributors,
    license: licenseSelector({ organization })
  };
};

const mapDispatchToProps = dispatch => ({
  ...dispatchify(dispatch, {
    getTeams,
    toggleModal,
    toggleSnackBar
  })
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(Contributor, 'Contributor Settings'));
